import React from "react"
import PropTypes from "prop-types"

import styles from "./PagingDots.module.scss"

const PagingDots = ({ slideCount, currentSlide, goToSlide, disable }) => {
    const dots = () => {
        const totalDots = []

        for (let i = 0; i < slideCount; i++) {
            totalDots.push(
                <li key={`dot${i}`}>
                    <button
                        className={`${styles.pagingDot} ${
                            i === currentSlide
                                ? `${styles.pagingDotActive}`
                                : ""
                        }
                            ${disable ? `${styles.pagingDotDisabled}` : ""}
                            `}
                        onClick={() => goToSlide(i)}
                        type="button"
                        disabled={disable}
                    >
                        &bull;
                    </button>
                </li>
            )
        }

        return totalDots
    }

    return <ul className={styles.pagingDotList}>{dots().map(el => el)}</ul>
}

PagingDots.defaultProps = {
    goToSlide: null,
    disable: false,
}

PagingDots.propTypes = {
    slideCount: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
    goToSlide: PropTypes.func,
    disable: PropTypes.bool,
}

export default PagingDots
